import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  Button,
  Divider,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { infoTextMap } from "../../../Helpers/constants";
import { esignToolApi } from "../../../services/esignApi";
import OTPSection from "../../../pages/MyProfile/OTPSection";
import { EmailIcon, VerifiedIcon } from "../../../assets/icons";
import NewPassword from "../../../pages/MyProfile/NewPassword";

const Body = (props) => {
  const { currentStep, setCurrentStep, formData, handleChange, passwordError } = props;
  const { profileData } = useSelector((state) => state.profile);

  const [loading, setLoading] = useState(false);

  const handleOTPSend = async () => {
    
    setLoading(true);
    try {
      const response = await esignToolApi.sendOtpForgotPassword(
        profileData?.company_email
      );
      console.log(response);
      if (response && response.status === true) {
        setCurrentStep("otpSent");
      }
    } catch (error) {
      toast.error("Error sending OTP Try Again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: "20px 30px",
        height: "calc(100% - 180px)",
        overflow: "auto",
      }}
    >
      <Grid
        container
        rowSpacing={3}
        sx={{ flexDirection: "column !important" }}
      >
        <Grid item xs={12} md={currentStep === "verified" ? 6 : 5}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              disabled
              name="email"
              placeholder="Email"
              value={profileData?.company_email}
              sx={{
                mr: 1,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  height: "46px",
                  borderColor: "#C0C0C0",
                  backgroundColor: "none",
                  "&:hover fieldset": {
                    borderColor: "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: "10px",
                  height: 45,
                  fontSize: "16px",
                  fontWeight: "400",
                },
              }}
            />
            {currentStep === "verified" && <VerifiedIcon />}
          </Box>
          {infoTextMap[currentStep] && (
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "22px",
                color: "#5C5C5C",
                mt: "20px",
                textAlign: "left",
              }}
            >
              {infoTextMap[currentStep]}
            </Typography>
          )}
          {!currentStep && (
            <Box sx={{ textAlign: "start" }}>
              <Button
                disabled={loading}
                variant="contained"
                sx={{
                  mt: 2,
                  mr: 2,
                  height: 40,
                  color: "#fff",
                  width: "155px",
                  fontSize: "16px",
                  boxShadow: "none",
                  fontWeight: "500",
                  borderRadius: "10px",
                  background: "#185CB7",
                  textTransform: "none",
                  "&:hover": { background: "#185CB7" },
                }}
                onClick={handleOTPSend}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Send OTP"
                )}
              </Button>
            </Box>
          )}
        </Grid>

        {currentStep === "otpSent" && (
          <OTPSection setCurrentStep={setCurrentStep} />
        )}
        {currentStep === "verified" && (
          <NewPassword formData={formData} handleChange={handleChange} passwordError={passwordError}/>
        )}
      </Grid>
    </Box>
  );
};

export default Body;
